import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('CloudExercise', LATEST_SCHEMA_VERSION.CloudExercise);
export default exerciseTypeVersionAdapter;